<template>
  <div class="card" :class="{ disable: cantEdit }">
    <div class="d-flex justify-content-between">
      <div class="title">سوالات متداول</div>
      <div class="add-btn" @click="addItem">
        <i class="fa fa-plus"></i>
        <span>اضافه کردن سوال</span>
      </div>
    </div>
    <div class="mainContainer" id="q-continer">
      <draggable v-model="model" @start="drag = true" @end="checkedDraggedItem($event)">
        <div v-for="(section, index) in model" :key="index" draggable=".drag" style="cursor: move" :class="{ drag: section.order }" @mouseover="setActiveIndex(index)">
          <div class="mainSection">
            <div class="sectionHeader" :style="activeIndex === index ? 'background: #F8F9FA;' : ''">
              <BaseText :maxlength="2000" @input="section.title = $event" :value="section.title" title="عنوان سوال" placeholder="عنوان سوال" @focused="setActiveIndex(index)" />
            </div>
            <div @click="setSectionActiveIndex" class="subSectionContainer" :class="{ activeSubSection: activeIndex === index }">
              <div v-if="model.length && index === activeIndex" class="add__remove__container">
                <div @click="addItem" class="plus__container">
                  <i class="fa fa-plus"></i>
                </div>
                <div v-if="model.length > 0" @click="removeItem(index)" class="minus__container">
                  <i class="fa fa-minus"></i>
                </div>
              </div>
              <div class="change__sort__button">
                <div class="change__sort" @click="sortUp(index)">
                  <i class="fa-regular fa-angle-up"></i>
                </div>
                <div class="change__sort" @click="sortDown(index)">
                  <i class="fa-regular fa-angle-down"></i>
                </div>
              </div>
              <div class="w-100 ps-3">
                <TextAreaInput @input="section.description = $event" :value="section.description" title="توضیحات" @focused="setActiveIndex(index)" />
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <Toast title="سوالات با موفقیت ثبت شد" :showToast="saved" />
    <Toast title="پرکردن تمام سوالات و توضیحات الزامی است" :showToast="isEmpty" :error="true" />
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.go(-1)">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="updateQuestions">ثبت</b-button>
    </div>
    <Loader v-if="loading" />
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import BaseText from '../../common/form/formModules/BaseText.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import skillUpFrequentlyAskedQuestionsProvider from '../../../services/skillUp/question'
import Loader from '../../widgets/loader.vue'
import Toast from '../../common/Toast.vue'
export default {
  components: { draggable, BaseText, TextAreaInput, Loader, Toast },
  data() {
    return {
      model: [
        {
          title: '',
          description: '',
          order: 0,
        },
      ],
      activeIndex: 0,
      isEmpty: false,
      saved: false,
      loading: false,
      cantEdit: false,
    }
  },

  async mounted() {
    this.loading = true
    await this.fetchQuestions()
    this.loading = false
    setTimeout(() => {
      this.cantEdit =
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (localStorage.getItem('productStatus') == 4 || localStorage.getItem('productStatus') == 3)
    }, 500)
  },
  methods: {
    checkedDraggedItem(e) {
      const findMovedItem = this.model.find((item) => (item.order = e.oldIndex))
      findMovedItem.order = e.newIndex
      const findReplacedItem = this.model.find((item) => item.order === e.newIndex)
      findReplacedItem.order = e.oldIndex
    },
    async fetchQuestions() {
      const req = await skillUpFrequentlyAskedQuestionsProvider.getQuestions(this.$route.params.courseId)
      if (req.data.data.output.length) {
        this.model = req.data.data.output.sort((a, b) => a.order - b.order)
      }
    },
    async updateQuestions() {
      this.loading = true
      this.model.forEach((item) => {
        if (this.model.length > 1 && !item.title) {
          this.isEmpty = true
          setTimeout(() => {
            this.isEmpty = false
          }, 3000)
        }
      })
      if (!this.isEmpty) {
        this.model.forEach((item, index) => {
          return (item.order = index)
        })
        const data = {
          courseId: +this.$route.params.courseId,
          frequentlyAskedQuestions: this.model[0].title ? this.model : [],
        }
        const req = await skillUpFrequentlyAskedQuestionsProvider.addFrequentlyAskedQuestions(data)
        if (req.status === 200) {
          this.saved = true
          this.fetchQuestions()
          setTimeout(() => {
            this.saved = false
          }, 3000)
        }
      }
      this.loading = false
    },
    setActiveIndex(index) {
      this.activeIndex = index
    },
    setSectionActiveIndex() {},
    addItem() {
      const lastItem = this.model.length - 1
      this.model.push({ title: '', description: '', order: this.model[lastItem].order + 1 })
      setTimeout(() => {
        const continer = document.getElementById('q-continer')
        continer.scrollTop = continer.scrollHeight
      }, 200)
    },
    removeItem(index) {
      if (this.model.length > 1) {
        this.model.splice(index, 1)
      }
    },
    sortUp() {},
    sortDown() {},
  },
}
</script>
<style lang="scss" scoped>
.mainContainer {
  scroll-behavior: smooth;
  background: white;
  padding: 0 20px;
  margin-bottom: 20px;
  // height: calc(100vh - 310px);
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.mainContainer::-webkit-scrollbar {
  display: none;
}
.mainSection {
  border: 1px solid #f0f1f1;
  margin-bottom: 20px;
  border-radius: 5px;
}
.sectionHeader {
  padding: 30px;
  border-radius: 5px 5px 0 0;
  cursor: move;
  user-select: none;
}
.subSectionContainer {
  padding: 30px;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: flex-start;
  position: relative;
  cursor: move;
  user-select: none;
}
.subSectionContainer:last-child {
  border-radius: 5px;
}

.activeSubSection {
  background: #f8f9fa;
  border-top: 1px dashed #ced4da;
  border-bottom: 1px dashed #ced4da;
  &:last-child {
    border-bottom: none;
  }
}
.add__remove__container {
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.plus__container {
  background: #34c38f;
  height: 20px;
  width: 20px;
  display: grid;
  place-items: center;
  border-radius: 100%;
  margin-bottom: 10px;
  cursor: pointer;
  i {
    color: white;
  }
}
.minus__container {
  background: #ff4861;
  height: 20px;
  width: 20px;
  display: grid;
  place-items: center;
  border-radius: 100%;
  cursor: pointer;
  i {
    color: white;
  }
}
.change__sort__button {
  position: absolute;
  right: -7px;
  top: 50%;
  transform: translateY(-50%);
}
.change__sort {
  background: #74788d;
  padding: 5px 3px;
  display: grid;
  place-items: center;
  border-radius: 1px;
  i {
    color: white;
    font-size: 10px;
  }
}

.title {
  font-size: 14px;
  margin: 33px 23px 0 auto;
}

.add-btn {
  padding: 8px 18px;
  background: #556ee6;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  margin: 30px;
  i {
    margin-left: 8px;
    color: #fff;
  }
  cursor: pointer;
  transition: 0.3s ease-in;
  &:hover {
    background: darken(#556ee6, 7);
  }
}

.error {
  color: #ff4861;
  padding: 16px;
}

.submit {
  color: #34c38f;
  padding: 16px;
}

.disable {
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
}
</style>
